module.exports = __webpack_public_path__ + "static/phone-section-23627eeffa4b344f3f7edb11e1ffa571.png";